import { Component, Input } from "@angular/core";
import { SharedModule } from "@bb-vendure/admin-ui/core";
import { ChipComponent } from "./chip/chip.component";

interface ColorMap {
  state: string;
  background: string;
  color: string;
}

@Component({
  selector: "custom-order-state-label",
  templateUrl: "./order-state-label.component.html",
  styleUrls: ["./order-state-label.component.scss"],
  standalone: true,
  imports: [SharedModule, ChipComponent],
})
export class OrderStateLabelComponent {
  @Input() state: string;

  colorMap: ColorMap[] = [
    { state: "AddingItems", background: "#5A9BDC", color: "white" },
    { state: "ArrangingPayment", background: "#5A9BDC", color: "white" },
    { state: "Delivered", background: "#5AA9B0", color: "white" },
    { state: "Cancelled", background: "#B0B0B0", color: "white" },
    { state: "Draft", background: "#5A9BDC", color: "white" },
    { state: "PaymentAuthorized", background: "#5A9BDC", color: "white" },
    { state: "PaymentSettled", background: "#61A75A", color: "white" },
    { state: "PaymentError", background: "#D3302F", color: "white" },
    { state: "Shipping", background: "#8756CC", color: "white" },
    { state: "Shipped", background: "#F5A623", color: "white" },
  ];

  get chipColor() {
    return this.colorMap.find((color) => color.state === this.state);
  }
}
